module.exports = __webpack_public_path__ + "static/media/blytz-spinner.a42e816c.gif";